import React, { useEffect } from "react";

import Navbar from "./clientHom/Navbar";
import Footer from "./uniComponents/AndUsFooter";
import AboutAndUsHeroSection  from "./aboutAndUs/AboutAndUsHeroSection";
import AboutAndUsWhoWeAreSection from "./aboutAndUs/AboutAndUsWhoWeAreSection";
import AboutAndUsDifferenceSection from "./aboutAndUs/AboutAndUsDifferenceSection";
import AboutAndUsExpertiseSection from "./aboutAndUs/AboutAndUsExpertiseSection";
import AboutAndUsTPCGroupSection from "./aboutAndUs/AboutAndUsTPCGroupSection";
import AboutAndUsFinalCTASection from "./aboutAndUs/AboutAndUsFinalCTASection";

import "./AboutAndUsPage.css";

export default function AboutAndUsPage() {
  useEffect(() => {
    const previousTitle = document.title;

    document.title = "About &Us | AndUs";
    window.scrollTo(0, 0);

    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="about-andus-public-page">
      <Navbar />

      <main className="about-andus-public-page__main">
        <AboutAndUsHeroSection />
        <AboutAndUsWhoWeAreSection />
        <AboutAndUsDifferenceSection />
        <AboutAndUsExpertiseSection />
        <AboutAndUsTPCGroupSection />
        <AboutAndUsFinalCTASection />
        <div
          id="about-andus-page-content"
          className="about-andus-public-page__development-anchor"
          aria-hidden="true"
        />
      </main>

      <Footer />
    </div>
  );
}